import { useEffect } from "react"
import { useLocation } from "react-router-dom"

// Scrolls window to the top whenever the route (pathname or hash) changes
const ScrollToTop = () => {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // If navigating to a hash, try to scroll to that element first
    if (hash) {
      const id = hash.replace("#", "")
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" })
        return
      }
    }
    // Default: scroll to the top
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [pathname, hash])

  return null
}

export default ScrollToTop
